import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import * as _ from 'lodash';
import { Location } from '@angular/common';
import { ModalConfirmationPointsComponent } from 'src/app/components/modal-confirmation-points/modal-confirmation-points.component';
import { map, startWith } from 'rxjs/operators';
var ClientPointsFormComponent = /** @class */ (function () {
    function ClientPointsFormComponent(errorsService, zipCodeService, formBuilder, storeService, authService, router, route, snackBar, dialog, location, companiesService) {
        this.errorsService = errorsService;
        this.zipCodeService = zipCodeService;
        this.formBuilder = formBuilder;
        this.storeService = storeService;
        this.authService = authService;
        this.router = router;
        this.route = route;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.location = location;
        this.companiesService = companiesService;
        this.states = [];
        this.plans = [];
        this.userID = '';
        this.stores = [];
        this.user = [];
        this.storeName = '';
        this.store = [];
        this.params = { formGroupValue: [] };
        this.initForm().catch(function (e) { return console.log(e); });
    }
    ClientPointsFormComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.route.queryParams.subscribe(function (params) {
                            _this.params.formGroupValue = params.formGroupValue;
                        });
                        this.userID = this.route.snapshot.paramMap.get('customerID');
                        this.architects = this.route.snapshot.paramMap.get('architects');
                        this.loadInfosUser();
                        if (!this.architects) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadStoresArchitects().catch(function (e) { return console.log(e); })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.loadStores()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ClientPointsFormComponent.prototype.initForm = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.formGroup = this.formBuilder.group({
                    name: [{ value: null, disabled: true }, [Validators.required]],
                    cpf: [{ value: null, disabled: true }, [Validators.required]],
                    jcoins: [
                        null,
                        [Validators.required, Validators.min(1), Validators.pattern('^(0|[1-9][0-9]*)$')],
                    ],
                    pointsConversionFactorOut: [{ value: null, disabled: true }, []],
                    store: [null, [Validators.required]],
                    commit: ['', [Validators.max(60)]],
                });
                this.storeOptions = this.formGroup.controls.store.valueChanges.pipe(startWith(''), map(function (value) {
                    return _this.stores.filter(function (store) {
                        var newValue = typeof value === 'object' ? value.nomeFantasia : value;
                        return (store.nomeFantasia.toLowerCase().includes(newValue.toLowerCase()) ||
                            store.razaoSocial.toLowerCase().includes(newValue.toLowerCase()) ||
                            store.cnpj.toLowerCase().includes(newValue.toLowerCase()));
                    });
                }));
                return [2 /*return*/];
            });
        });
    };
    ClientPointsFormComponent.prototype.loadInfosUser = function () {
        var _this = this;
        this.authService.customerUserInfo(this.userID).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.user = response;
                this.formGroup.patchValue({
                    name: response.firstName + ' ' + response.lastName,
                    cpf: response.cpf,
                });
                return [2 /*return*/];
            });
        }); }, function (error) {
            console.log(error);
            _this.snackBar.open(error.error.message);
        });
    };
    ClientPointsFormComponent.prototype.loadStoresArchitects = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var stores;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.companiesService
                            .listStoresBusinessUnits()
                            .catch(function (err) {
                            _this.snackBar.open(err.message);
                            return { stores: [], TotalRegisters: 0 };
                        })];
                    case 1:
                        stores = (_a.sent()).stores;
                        this.stores = stores;
                        return [2 /*return*/];
                }
            });
        });
    };
    ClientPointsFormComponent.prototype.loadStores = function () {
        var _this = this;
        this.storeService.listStores().subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.stores = response;
                return [2 /*return*/];
            });
        }); }, function (error) {
            console.log(error);
            _this.snackBar.open(error.error.message);
        });
    };
    ClientPointsFormComponent.prototype.calcValuePoints = function (event) {
        this.formGroup.patchValue({
            store: this.formGroup.value.store,
            jcoins: event.target.value,
            pointsConversionFactorOut: this.formGroup.value.jcoins * (this.store[0].pointsConversionFactorOut / 100),
        });
        this.pointsConversionFactorOut =
            this.formGroup.value.jcoins * (this.store[0].pointsConversionFactorOut / 100);
    };
    ClientPointsFormComponent.prototype.displayStore = function (store) {
        return store ? "" + store.nomeFantasia : '';
    };
    ClientPointsFormComponent.prototype.calcValue = function (event) {
        var _this = this;
        this.stores.forEach(function (store) {
            if (store.id == event.option.value.id) {
                _this.store.push(store);
                _this.storeName = store.nomeFantasia;
                _this.pointsConversionFactorOut =
                    _this.formGroup.value.jcoins * (_this.store[0].pointsConversionFactorOut / 100);
                _this.formGroup.patchValue({
                    store: _this.formGroup.value.store,
                    pointsConversionFactorOut: _this.formGroup.value.jcoins * (_this.store[0].pointsConversionFactorOut / 100),
                });
            }
        });
    };
    ClientPointsFormComponent.prototype.goBack = function () {
        // this.location.back()
        if (this.architects) {
            this.router.navigate(['./dashboard/clients-architect/architect']);
        }
        else {
            this.router.navigate(['./dashboard/clients']);
        }
    };
    ClientPointsFormComponent.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this.formGroup.valid) {
                    this.snackBar.open('Preencha corretamente os campos e tente novamente.');
                    return [2 /*return*/, false];
                }
                if (!this.formGroup.value.store || !_.isObject(this.formGroup.value.store)) {
                    this.snackBar.open('Preencha corretamente o campo Parceiro.');
                    return [2 /*return*/, false];
                }
                if (this.formGroup.value.commit.length > 60) {
                    this.snackBar.open('O campo Comentário tem limite máximo de 60 caracteres');
                    return [2 /*return*/, false];
                }
                data = {
                    customerId: this.userID,
                    storeId: this.formGroup.value.store.id,
                    jcoins: parseInt(this.formGroup.value.jcoins),
                    commit: this.formGroup.value.commit,
                };
                dialogRef = this.dialog.open(ModalConfirmationPointsComponent, {
                    width: '500px',
                    data: {
                        store: this.storeName,
                        points: this.formGroup.value.jcoins,
                        value: this.pointsConversionFactorOut,
                    },
                });
                dialogRef.afterClosed().subscribe(function (result) {
                    if (result && result != 'cancel') {
                        _this.authService.applyPoints(data).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                this.snackBar.open('Pontos creditados com sucesso.');
                                if (this.architects) {
                                    this.router.navigate(['./dashboard/clients-architect/architect']);
                                }
                                else {
                                    this.router.navigate(['./dashboard/clients']);
                                }
                                return [2 /*return*/];
                            });
                        }); }, function (error) {
                            console.log(error.error.message);
                            _this.snackBar.open(error.error.message);
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    return ClientPointsFormComponent;
}());
export { ClientPointsFormComponent };
